/* Shared cart state and free-shipping meter. Consumed by toast, header, drawer and PDP meters. */
(function () {
  var doc = document;
  var strings = {};
  try { strings = JSON.parse(doc.getElementById('rh-cart-strings').textContent); } catch (e) {}

  var RHCart = (window.RHCart = {
    threshold: parseInt(doc.body.getAttribute('data-rh-free-shipping'), 10) || 0,

    remaining: function (total, extra) {
      return Math.max(0, RHCart.threshold - total - (extra || 0));
    },

    percent: function (total, extra) {
      if (!RHCart.threshold) return 100;
      return Math.min(100, Math.max(0, ((total + (extra || 0)) / RHCart.threshold) * 100));
    },

    // Re-render meters from the last known cart total, no fetch.
    // shortcut: the first call before any refresh has no cached total, so it falls back to one /cart.js fetch.
    render: function () { if (RHCart.total == null) RHCart.refresh().catch(function () {}); else renderMeters({ total_price: RHCart.total }); },

    refresh: function () {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); })
        .then(function (cart) {
          RHCart.total = cart.total_price;
          renderMeters(cart);
          doc.dispatchEvent(new CustomEvent('rh:cart:updated', { detail: { cart: cart } }));
          return cart;
        })
        .catch(function (e) {
          doc.dispatchEvent(new CustomEvent('rh:cart:error', { detail: { message: e.message } }));
          throw e;
        });
    },
  });

  function money(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, window.Shopify.money_format || '${{amount}}');
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function renderMeters(cart) {
    doc.querySelectorAll('[data-rh-meter]').forEach(function (el) {
      var extra = +el.dataset.extra || 0;
      var left = RHCart.remaining(cart.total_price, extra);
      var started = cart.total_price + extra > 0;
      var tpl = left === 0
        ? (el.dataset.style === 'header' ? strings.header_done : strings.ship_free)
        : el.dataset.style === 'header'
          ? (started ? strings.header_remaining : strings.header_default)
          : strings.ship_remaining;
      var msg = el.querySelector('.rh-meter__msg');
      var bar = el.querySelector('.rh-meter__bar > i');
      // The threshold in the default header copy is a round number: show $150, not $150.00 (matches the announcement bar).
      var amount = tpl === strings.header_default ? money(RHCart.threshold).replace(/[.,]00(?!\d)/, '') : money(left || RHCart.threshold);
      if (msg && tpl) msg.innerHTML = tpl.replace(/{{\s*amount\s*}}/g, amount);
      if (bar) bar.style.width = RHCart.percent(cart.total_price, extra).toFixed(1).replace(/\.0$/, '') + '%';
    });
    syncRing();
  }

  // Below 1000px the header meter is hidden and a ring round the Cart count shows its fill (assets/rh-header-tracker.css).
  // Set on <html>, not the badge: cart-icon-bubble is re-rendered after every cart change.
  function syncRing() {
    var bar = doc.querySelector('[data-rh-meter][data-style=header] .rh-meter__bar > i');
    if (bar) doc.documentElement.style.setProperty('--rh-ship-pct', parseFloat(bar.style.width) || 0);
  }
  syncRing();

  // Drawer/cart-page quantity changes and Remove fire cart:updated (assets/cart.js); re-render the meters.
  doc.addEventListener('cart:updated', function () { RHCart.refresh().catch(function () {}); });

  // PDP meter: extra = unit pay price (data-unit, from the server) x quantity; no fetch.
  doc.addEventListener('input', function (e) { pdpQty(e.target); });
  doc.addEventListener('change', function (e) { pdpQty(e.target); });
  function pdpQty(input) {
    if (!input.matches || !input.matches('input[name=quantity]')) return;
    doc.querySelectorAll('[data-rh-meter][data-style=pdp][data-unit]').forEach(function (el) {
      el.dataset.extra = (+el.dataset.unit || 0) * Math.max(1, parseInt(input.value, 10) || 1);
    });
    RHCart.render();
  }

  // Pulse the header count badge when something is added.
  doc.addEventListener('rh:cart:added', function () {
    doc.querySelectorAll('.rh-cart-count').forEach(function (el) {
      el.classList.remove('rh-cart-count--bump');
      void el.offsetWidth;
      el.classList.add('rh-cart-count--bump');
    });
  });
})();
